"use strict";

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _colors = _interopRequireDefault(require("../../constants/colors"));

var _spacing = _interopRequireDefault(require("../../constants/spacing"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tlist-style: none;\n\tmargin: 0;\n\tpadding: 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: inline-block;\n\tcursor: pointer;\n\t&:after {\n\t\tdisplay: inline-block;\n\t\tmargin: 0 ", ";\n\t\tcontent: '/';\n\t\tcolor: ", ";\n\t}\n\n\t&:last-child:after {\n\t\tdisplay: none;\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

var Crumb = _styledComponents.default.li(_templateObject(), _spacing.default.s1, _colors.default.grey);

Crumb.displayName = 'Crumb';

var Crumbs = _styledComponents.default.ul(_templateObject2());

Crumbs.displayName = 'Crumbs';

var Breadcrumbs = function Breadcrumbs(_ref) {
  var crumbs = _ref.crumbs,
      _onClick = _ref.onClick,
      Icon = _ref.Icon,
      rest = _objectWithoutPropertiesLoose(_ref, ["crumbs", "onClick", "Icon"]);

  return _react.default.createElement(Crumbs, rest, Icon && _react.default.createElement(Icon, {
    size: 20,
    color: _colors.default.borderColor,
    className: "mr-1"
  }), crumbs.map(function (crumb, i) {
    return _react.default.createElement(Crumb, {
      key: crumb.link,
      onClick: function onClick() {
        return i === crumbs.length - 1 ? null : _onClick(crumb.link);
      }
    }, crumb.name);
  }));
};

Breadcrumbs.displayName = 'Breadcrumbs';
Breadcrumbs.propTypes = {
  crumbs: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    link: _propTypes.string,
    name: _propTypes.string
  })).isRequired,
  onClick: _propTypes.func,
  Icon: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.bool])
};
Breadcrumbs.defaultProps = {
  Icon: false,
  onClick: function onClick() {}
};
var _default = Breadcrumbs;
exports.default = _default;